<div class="modal-header">
  <h4 class="modal-title">{{ 'chat.browse.title' | translate }}</h4>
  <button type="button" class="btn-close" [attr.aria-label]="'chat.dialog.cancel' | translate" (click)="close()"></button>
</div>

<div class="modal-body">
  <p class="text-muted mb-2">{{ 'chat.browse.subtitle' | translate }}</p>

  <div class="mb-2">
    <input
      type="text"
      class="form-control"
      name="chatBrowseFilter"
      [placeholder]="'chat.browse.searchPlaceholder' | translate"
      [attr.aria-label]="'chat.browse.searchPlaceholder' | translate"
      [(ngModel)]="searchTerm"
      (input)="applyFilter()"
    >
  </div>

  @if ((loading$ | async) && rows.length === 0) {
    <chat-sidebar-skeleton [rows]="5"></chat-sidebar-skeleton>
  } @else if (rows.length === 0) {
    <chat-empty-state
      icon="ri-hashtag"
      titleKey="chat.browse.empty"
      hintKey="chat.browse.emptyHint"
      [compact]="true"
    ></chat-empty-state>
  } @else {
    <div class="list-group list-group-flush chat-browse-list overflow-auto">
      @for (row of rows; track trackRow($index, row)) {
        <div class="list-group-item d-flex align-items-center gap-2 py-2">
          <span class="avatar-xs rounded-circle bg-soft-primary flex-shrink-0">
            <i class="ri-hashtag avatar-title text-primary"></i>
          </span>

          <span class="flex-grow-1 overflow-hidden">
            <span class="d-flex align-items-center gap-1">
              <span class="chat-name fw-semibold">{{ row.name }}</span>
              @if (row.archived) {
                <span class="badge bg-soft-warning text-warning flex-shrink-0">
                  {{ 'chat.conversation.archived' | translate }}
                </span>
              }
            </span>
            <small class="d-block text-muted text-truncate">
              {{ 'chat.browse.memberCount' | translate:{ count: row.memberCount } }}
              @if (row.description) {
                <span> · {{ row.description }}</span>
              }
            </small>
          </span>

          @if (row.isMember) {
            <button type="button" class="btn btn-sm btn-light flex-shrink-0" (click)="open(row)">
              <i class="ri-arrow-right-line me-1"></i>{{ 'chat.browse.open' | translate }}
            </button>
          } @else {
            <!-- Non-members can still open the read-only preview (DEV-1984). -->
            <button type="button" class="btn btn-sm btn-light flex-shrink-0" (click)="open(row)">
              <i class="ri-arrow-right-line me-1"></i>{{ 'chat.browse.open' | translate }}
            </button>
            <button
              type="button"
              class="btn btn-sm btn-soft-primary flex-shrink-0"
              [disabled]="joiningId === row.id"
              (click)="join(row)"
            >
              @if (joiningId === row.id) {
                <span class="spinner-border spinner-border-sm me-1" role="status"></span>
                <span>{{ 'chat.browse.joining' | translate }}</span>
              } @else {
                <span><i class="ri-add-line me-1"></i>{{ 'chat.browse.join' | translate }}</span>
              }
            </button>
          }
        </div>
      }
    </div>

    @if (hasMore) {
      <div class="text-center pt-2">
        <button type="button" class="btn btn-sm btn-light" [disabled]="loading$ | async" (click)="loadMore()">
          @if (loading$ | async) {
            <span class="spinner-border spinner-border-sm me-1" role="status"></span>
          }
          {{ 'chat.browse.loadMore' | translate }}
        </button>
      </div>
    }
  }
</div>

<div class="modal-footer justify-content-between">
  <small class="text-muted">{{ 'chat.browse.resultCount' | translate:{ count: total } }}</small>
  <button type="button" class="btn btn-light" (click)="close()">{{ 'chat.browse.close' | translate }}</button>
</div>
